// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import '../theme/index.css'
import ElementUI from 'element-ui'

import Vue from 'vue'
import VueFire from 'vuefire'
import VueRouter from 'vue-router'
import DataTables from 'vue-data-tables'
import store from './store/store'
import { authService } from './helpers/helpers'

Vue.use(VueFire)
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(DataTables)

import App from './App'
import Login from './components/Login'
import Reset from './components/Reset'
import Confirm from './components/Confirm'
import Users from './components/Users'
import User from './components/User'
import Projects from './components/Projects'
import Project from './components/Project'
import NotFound from './components/NotFound'

function loginRequired (to, from, next) {
  if (authService.authenticated()) {
    next()
  } else {
    router.push('/')
  }
}

const router = new VueRouter({
  // mode: 'history',
  routes: [
    { path: '/', components: { default: Projects, entry: Login } },
    { path: '/reset', components: { default: Projects, entry: Reset } },
    { path: '/confirm-password', components: { default: Projects, entry: Confirm } },
    { path: '/users', component: Users, beforeEnter: loginRequired },
    { path: '/users/:id', component: User, beforeEnter: loginRequired },
    { path: '/projects', component: Projects, beforeEnter: loginRequired },
    { path: '/projects/:id', component: Project, beforeEnter: loginRequired },
    { path: '*', component: NotFound }
  ],
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.activeLink = to.path
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.activeLink = to.path
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js